// @flow
import xws from 'api/xws/';
import qs from 'query-string';

// Constants
import { getService } from 'constants/ajax';

type RequestData = {|
  tokenId: string,
  event: string,
  attribute_1: string,
  attribute_2: string
|};

type Props = {|
  params: RequestData,
  webkey: string
|};

export async function saveStats({ params, webkey }: Props): any {
  try {
    const saveStatsService = getService('saveStats');
    saveStatsService.setPathVars({ webkey });
    await xws(saveStatsService).post(
      saveStatsService.getPath(),
      qs.stringify(params)
    );
  } catch (e) {
    /* eslint-disable no-console */
    console.error(e);
    /* eslint-enable no-console */
  }
}



// WEBPACK FOOTER //
// ./src/api/xws/saveStats/saveStatsWs.js